import React, { useEffect } from 'react';
import { useSelect, useAction } from 'hooks';
import { Input, Icon, Button } from 'components';
import { get, debounce } from 'lodash';
import { withForm, withFormValidation } from 'hoc';
import TransactionHistorySelect from 'containers/transaction-history/TransactionHistorySelect';

const SelectedServiceInitialForm = ({ value, onChange, helperMessage, isPassed, onChangeIsPassed, onSetObjectRules, onSetForm }) => {
  const selectedTransaction = useSelect('transaction.selected', { id: process.env.REACT_APP_DEFAULT_TRANSACTION })
  const ownershipTypeGetList = useAction('ownershipType.getList')
  const ownershipTypeList = useSelect('ownershipType.list')
  
  const selectedTransactionTypes = useSelect('transaction.selectedTransactionTypes', { id: process.env.REACT_APP_DEFAULT_TRANSACTION })
  const ownershipTypeListing = useSelect('loading.isLoading', { type: 'ownershipType.getList' })
  const setSelectedTransactionType = useAction('transactionType.show')
  const setSelectedOwnershipType = useAction('ownershipType.show')

  const transactionTypeOptions = Object.values(selectedTransactionTypes).map(type => {
    return {
      label: get(type, 'attributes.name'),
      value: `${get(type, 'id')}`
    }
  }) || []

  const ownershipTypeOptions = Object.values(ownershipTypeList).map(owntype => {
    return {
      label: get(owntype, 'attributes.name'),
      value: `${get(owntype, 'id')}`
    }
  })

  const firstTransactionType = transactionTypeOptions.shift()
  
  useEffect(() => {
    ownershipTypeGetList()
  // eslint-disable-next-line
  }, [])

  useEffect(() => {
    onChangeIsPassed(isPassed)
    // eslint-disable-next-line
  }, [isPassed])

  useEffect(() => {  
    setSelectedTransactionType(value.transaction_type_id)
  // eslint-disable-next-line
  }, [value.transaction_type_id])

  useEffect(() => {
    setSelectedOwnershipType(value.ownership_type_id)
  // eslint-disable-next-line
  }, [value.ownership_type_id])

  const saveToLocalStorage = debounce((key, data) => {
    localStorage.setItem(key, JSON.stringify(data))
  // eslint-disable-next-line
  }, 100)

  useEffect(() => {
    saveToLocalStorage('app_transaction', value)
  // eslint-disable-next-line
  }, [Object.values(value).join(',')])

  
  useEffect(() => {

    if(value.transaction_kind === 1){
      onSetObjectRules({
        transaction_kind: 'required',
        ownership_type_id: 'required',
        transaction_type_id: 'required'
      })

      onSetForm({
        ...value,
        transaction_kind: 1,
        ownership_type_id: '1',
        
        transaction_type_id: get(firstTransactionType, 'value'),
      })
    }

    if(value.transaction_kind === 2){
      onSetObjectRules({
        transaction_kind: 'required',
        transaction_type_multiple: 'required',
        payment_id: 'required'
      })

      onSetForm({
        ...value,
        transaction_kind: 2,
        transaction_type_id: '',
        transaction_type_multiple: [],
        payment_id: ''
      })
    }
  // eslint-disable-next-line
  }, [value.transaction_kind, get(firstTransactionType, 'value')])


  useEffect(() => {
    
    if(value.transaction_kind === 2){

      const transactionType = transactionTypeOptions.find(x => x.value === value.transaction_type_id) || null
      if(transactionType)
        onSetForm({
          ...value,
          transaction_type_id: '',
          transaction_type_multiple: [
            ...value.transaction_type_multiple,
            transactionType
          ]
        })
    }
  // eslint-disable-next-line
  }, [value.transaction_kind, value.transaction_type_id])
  
  const selectedTransactionTypeIds = get(value, 'transaction_type_multiple', []).map(x => x.value) || []
  
  const onDeleteTransactionType = data => e => {
    e.preventDefault()
    onSetForm({
      ...value,
      transaction_type_multiple: value.transaction_type_multiple.filter(x => x.value !== data.value)
    })
  }
  
  return (
    <div className="flex flex-col my-2">
      {selectedTransaction ? 
        <div className="flex-1 border-2 border-gray-300 px-2 py-2 xl:px-10 xl:py-10 lg:px-5 lg:py-5   text-center">
          <span className="text-primary font-medium xl:font-bold lg:font-bold">{get(selectedTransaction, 'attributes.name')}</span>
        </div> : 
        null
      }
      <form>
        <div className="pt-5 flex items-center justify-center">
          <Input 
            className="!w-auto"
            label="" 
            name="transaction_kind" 
            type="option_radio" 
            options={[
              {
                label: 'New',
                value: 1,
              },
              {
                label: 'Others',
                value: 2,
                className: 'line-through'
              }
            ]} 
            value={value.transaction_kind} 
            onChange={() => {}} 
            helperMessage={helperMessage}/>
        </div>
        {value.transaction_kind === 1 &&
        <div className="grid grid-cols-1">
          <Input isLoading={ownershipTypeListing} label="Type of Ownership" name="ownership_type_id" type="select" options={ownershipTypeOptions} value={value.ownership_type_id} onChange={onChange} helperMessage={helperMessage}/>
        </div>}
        {value.transaction_kind === 2 &&
          <div className="bg-gray-100 p-2 rounded">
            <div className="grid xl:!grid-cols-1 lg:!grid-cols-1 grid-cols-1">
              <TransactionHistorySelect  
                name="payment_id"
                onChange={onChange}
                value={`${value.payment_id}`} 
                helperMessage={helperMessage}
              />
              {/* <Input isLoading={ownershipTypeListing} label="Type of Ownership" name="ownership_type_id" type="select" options={ownershipTypeOptions} value={value.ownership_type_id} onChange={onChange} helperMessage={helperMessage}/> */}
              <Input 
                label="Transaction Type" 
                name="transaction_type_id" 
                type="select" 
                options={transactionTypeOptions.filter(x => selectedTransactionTypeIds.indexOf(x.value) < 0)} 
                value={`${value.transaction_type_id}`} 
                onChange={onChange} 
                helperMessage={helperMessage}
                />
            </div>
            <ul className="flex flex-col space-y-2">
              {get(value, 'transaction_type_multiple', []).length > 0 && get(value, 'transaction_type_multiple', []).map(x => {
                return (
                  <li className="flex items-center space-x-3 text-sm">
                    <Button onClick={onDeleteTransactionType(x)} type="button" className="!bg-transparent !w-auto !p-0 !h-5 !m-0"><Icon.Trash /></Button>
                    <p>{x.label}</p>
                  </li>
                )
              })}
              {get(value, 'transaction_type_multiple', []).length === 0 && 
                <li className="flex items-center justify-center text-sm text-info">
                  <p>You can select 1(one) or multiple transaction type</p>
                </li>
              }
            </ul>
          </div>
        }
      </form>
    </div>
  )
}

export default withForm(
  withFormValidation(SelectedServiceInitialForm, {
    transaction_kind: 'required',
    ownership_type_id: 'required'
  }), {
  ownership_type_id: '1',
  transaction_kind: 1,
  transaction_type_id: '',
  transaction_type_multiple: [],
});